import React from 'react';
import PropTypes from 'prop-types';

function StatusCell({ dataItem }) {
  const { status, statusIcon, statusColor } = dataItem;

  return (
    <td>
      <span className="qmb-avatar--24--status-icon">
        <i className={`fa-lg ${statusIcon}`} style={{ color: statusColor }} />
      </span>
      <span style={{ marginLeft: '0.5rem' }}>{status}</span>
    </td>
  );
}

StatusCell.propTypes = {
  dataItem: PropTypes.shape({
    status: PropTypes.string.isRequired,
    statusIcon: PropTypes.string.isRequired,
    statusColor: PropTypes.string.isRequired
  }).isRequired
};

export default StatusCell;
